<template>
    <!-- Links Section -->
	<section class="section info-section">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					<div class="accordion accordion-links">
						<div class="accordion-item wow fadeInUp bg-transparent" data-wow-delay="0.2s">
							<h2 class="accordion-header">
								<button class="accordion-button bg-transparent px-0" type="button" data-bs-toggle="collapse"
									data-bs-target="#professional" aria-expanded="false">
									Our Professions Near You
								</button>
							</h2>
							<div id="professional" class="accordion-collapse collapse show">
								<div class="accordion-body border-0 px-0">
									<div class="row row-cols-xl-6 row-cols-md-4 row-cols-sm-2 row-cols-1">
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Appliance Repair</a>
												<a href="javascript:void(0);">Flooring</a>
												<a href="javascript:void(0);">Garage Doors</a>
												<a href="javascript:void(0);">Fencing</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Carpet Cleaning</a>
												<a href="javascript:void(0);">Driveways</a>
												<a href="javascript:void(0);">Gutter Cleaning</a>
												<a href="javascript:void(0);">Land Surveying</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Contractors</a>
												<a href="javascript:void(0);">Exterior Painting</a>
												<a href="javascript:void(0);">Gutter Repair</a>
												<a href="javascript:void(0);">Landscaping</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Drywall </a>
												<a href="javascript:void(0);">Plumbing</a>
												<a href="javascript:void(0);">Home Builders</a>
												<a href="javascript:void(0);">Lawn & Yard Work</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Electrical & Services</a>
												<a href="javascript:void(0);">Remodeling</a>
												<a href="javascript:void(0);">Home Builders</a>
												<a href="javascript:void(0);">Sprinkler Systems</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">House Cleaning</a>
												<a href="javascript:void(0);">Interior Painting</a>
												<a href="javascript:void(0);">Roofing</a>
												<a href="javascript:void(0);">More Services</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="accordion-item mb-0 wow fadeInUp bg-transparent" data-wow-delay="0.2s">
							<h2 class="accordion-header">
								<button class="accordion-button bg-transparent px-0" type="button" data-bs-toggle="collapse"
									data-bs-target="#city" aria-expanded="false">
									Popular Cities
								</button>
							</h2>
							<div id="city" class="accordion-collapse collapse show">
								<div class="accordion-body border-0 px-0">
									<div class="row row-cols-xl-6 row-cols-md-4 row-cols-sm-2 row-cols-1">
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Detroit</a>
												<a href="javascript:void(0);">Greensboro</a>
												<a href="javascript:void(0);">Kansas City</a>
												<a href="javascript:void(0);">Memphis</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">El Paso</a>
												<a href="javascript:void(0);">Harrisburg</a>
												<a href="javascript:void(0);">Las Vegas</a>
												<a href="javascript:void(0);">Miami</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Fort Lauderdale</a>
												<a href="javascript:void(0);">Hartford</a>
												<a href="javascript:void(0);">Long Beach</a>
												<a href="javascript:void(0);">Milwaukee</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Fort Worth </a>
												<a href="javascript:void(0);">Houston</a>
												<a href="javascript:void(0);">Los Angeles</a>
												<a href="javascript:void(0);">Minneapolis</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Fresno</a>
												<a href="javascript:void(0);">Indianapolis</a>
												<a href="javascript:void(0);">Louisville</a>
												<a href="javascript:void(0);">Modesto</a>
											</div>
										</div>
										<div class="col">
											<div class="main-links">
												<a href="javascript:void(0);">Grand Rapids</a>
												<a href="javascript:void(0);">Jacksonville</a>
												<a href="javascript:void(0);">Madison</a>
												<a href="javascript:void(0);">Nashville</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /Links Section -->
</template>